import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { FuseSuspense } from '@fuse'
import { renderRoutes } from 'react-router-config'

const styles = (theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
})

export const FILTER_TYPE = {
  ACTIVE_AND_INACTIVE: -1,
  ACTIVE: 1,
  INACTIVE: 0,
}

const DealsPromotions = ({ route }) => {
  return <FuseSuspense>{renderRoutes(route.routes)}</FuseSuspense>
}

export default withStyles(styles, { withTheme: true })(DealsPromotions)
